import './App.css';

const whatsappUrl = 'https://wa.me/6591889109';
const instagramUrl = 'https://www.instagram.com/thepianogardensg/?hl=en';

const sections = [
  {
    title: 'Achievements',
    text: 'Prize moments that honour patient practice, brave performances, and the quiet work behind every polished piece.',
    image: '/assets/images/instagram/award-group.jpg',
  },
  {
    title: 'Recitals',
    text: 'Concert days where students gather, perform with poise, and celebrate music with family and friends.',
    image: '/assets/images/instagram/recital-performance.jpg',
  },
  {
    title: 'Festivals',
    text: 'Wider stages and shared experiences that help young musicians listen, travel, compete, and grow.',
    image: '/assets/images/instagram/competition-prize.jpg',
  },
];

function App() {
  return (
    <main className="site">
      <header className="nav" aria-label="Main navigation">
        <a className="brand" href="#top">The Piano Garden</a>
        <a className="contact-link" href={instagramUrl} target="_blank" rel="noreferrer">
          Instagram
        </a>
      </header>

      <section className="hero" id="top">
        <div className="hero-copy">
          <h1>The Piano Garden</h1>
          <p className="intro">Where music blossoms.</p>
          <a className="button" href={whatsappUrl} target="_blank" rel="noreferrer">
            Enquire
          </a>
        </div>
        <figure className="hero-image">
          <img src="/assets/images/instagram/studio-piano.webp" alt="The Piano Garden studio piano" />
        </figure>
      </section>

      <section className="statement" aria-label="Studio values">
        <p>Play with grace. Learn with joy. Grow with music.</p>
      </section>

      <section className="sections" aria-label="Highlights">
        {sections.map((section) => (
          <article className="feature" key={section.title}>
            <img src={section.image} alt="" />
            <div>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="closing">
        <p>New students are welcome.</p>
        <a className="button button-dark" href={whatsappUrl} target="_blank" rel="noreferrer">
          Contact
        </a>
      </section>
    </main>
  );
}

export default App;
